<template>
<el-dialog :close-on-click-modal="false" append-to-body :visible.sync="show" :title="title" width="400px">
  <div class="dialog-content"> 
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="120px">
      <el-form-item :label="label" prop="tagLabel">
        <el-input v-model="form.tagLabel" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <div slot="footer" class="dialog-footer">
    <el-button type="text" @click="$emit('close')">取消</el-button>
    <el-button type="primary" :disabled="isSumiting" v-loading="isSumiting" @click="submit">确认</el-button>
  </div>
</el-dialog>
</template>
<script>
import { addChannelTag, editChannelTag } from '@/service/apis/supShopTag'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editChannelTagRow: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: ''
    }
  },

  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    label () {
      return '渠道标签'
    },
    title () {
      return (this.editChannelTagRow ? '编辑' : '新增') + this.label
    }
  },
  watch: {
    show: {
      handler (val) {
        if (val) {
          if (this.editChannelTagRow) {
            this.form.tagLabel = this.editChannelTagRow.tagLabel
            this.form.tagLogo = this.editChannelTagRow.tagLogo
          } else {
            this.form.tagLabel = ''
            this.form.tagLogo = ''
          }
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      isSumiting: false,
      uploading: false,
      fileList: [],
      rules: {
        tagLabel: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        tagLogo: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ]
      },
      form: {
        tagLabel: '',
        tagLogo: ''
      }
    }
  },
  methods: {
    beforeUpload(file, key) {
      let isLt2M = true
      isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      // this.editChannelTagForm[key] = file.name
      this.uploading = true
      return isLt2M
    },
    handleChange(file) {
      let isLt2M = true
      isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.fileList = []
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
      const formData = new FormData()
      formData.append('media', file.raw)
      uploadImage(formData).then(({ data }) => {
        this.form.tagLogo = data.img
        this.uploading = false
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.uploading = false
      })
    },
    handleSuccess(response, file, fileList) {
      const url = this.baseApi + '/file/' + response.type + '/' + response.realName
      // const url = response.realName
      this.form.tagLogo = url
      this.uploading = false
    },
    handleError(e, file, fileList) {
      const msg = JSON.parse(e.message)
      this.$notify({
        title: msg.message,
        type: 'error',
        duration: 2500
      })
      this.uploading = false
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.editChannelTagRow) {
            editChannelTag.call(this, {
              id: this.editChannelTagRow.id,
              ...this.form
            }).then(res => {
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.$emit('on-success')
            })
          } else {
            addChannelTag.call(this, {
              ...this.form
            }).then(res => {
              this.$message({
                message: '新增成功',
                type: 'success'
              })
              this.$emit('on-success')
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
</style>